/**
 * Created by xiaoconghu on 2018/11/19.
 */

export default {
  local: 'en_US',
  table: 'table'
};
